import { render } from "./AboutUs.vue?vue&type=template&id=43d263ce"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
script.render = render

export default script